module.exports = __webpack_public_path__ + "static/hello-69c5fcf58284175b5a9ebcdd2ad4f49d.png";